export const html = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link
      href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap"
      rel="stylesheet"
    />
    <title>Tax Report from_date - to_date</title>
  </head>
  <style>
    body {
      max-width: 1000px;
      margin: 0 auto;
      font-family: Roboto;
    }
    @media print {
      body {-webkit-print-color-adjust: exact;}
      }


    .header {
      font-style: normal;
      text-align: center;
      font-weight: 600;
    }

    .divider {
      border: 1px solid #000000;
    }

    .signature {
      font-weight: 600;
      display: flex;
      align-items: center;
    }

    .spacer {
      flex: 1;
    }

    .underline {
      width: 200px;
      margin-left: 10px;
      margin-top: 8px;
      border-bottom: 1px solid #000000;
    }

    @media print {
      @page {
        margin: 0;
        margin-top: 0.8cm;
        size: portrait;

      }
      body {
        margin: 1.6cm;
        margin-top: 0px;
      }
    }
    table {
        width: 100%;  border-collapse: collapse;
    }
    table thead {
        background: #E6E6E6;
        font-size: 14px;
    }
    table tr td {
      padding:15px 10px;
    }
    table th {
      padding:15px 10px;
        text-align: left;
    }
  </style>

  <body>
    <h4 class="header">
      EL CHEAPO 24 HOUR MOBILE LOCKSMITH & ROAD SERVICES<br />
      3026 Midway drive, San Diego CA 92110<br />
      Locksmith license LCO#7316
    </h4>
    <div class="divider"></div>
    <div class="signature">
      <h4>
        Tax Report
      </h4>
      <div class="spacer"></div>
      <h4 class="date">From from_date - to_date</h4>
    </div>
    <div class="signature">
      <h4>Total Sales: <b>$total_sales</b></h4>
      <div class="spacer"></div>
      <h4>Labour Non Taxable Sales: <b>$total_non_tax_sales</b></h4>
    </div>
    <div class="signature">
      <h4>Total Taxable Sales: <b>$total_amount</b></h4>
      <div class="spacer"></div>
      <h4>Total Tax: <b>$total_tax</b></h4>
    </div>
    <table>
      <thead>
        <tr>
          <th>
            Job Create Date            
          </th>
          <th>
            Job Number
          </th>
          <th>
            Service
          </th>
          <th>
            Amount Paid
          </th>
          <th>
            Tax
          </th>
        </tr>
      </thead>
      <tbody>
        table_body
      </tbody>
    </table>
  </body>
</html>
`;
